import angular from 'angular';
import LocationAccessService from './locationAccess.service.js';
import LocationAccessSchema from './locationAccess.schema';

let locationAccessModule = angular.module('locationAccess', [])

    .service('LocationAccessService', LocationAccessService)
    .constant('LocationAccessSchema', LocationAccessSchema)
    .name;

export default locationAccessModule;
